import { useMemo } from 'react';
import type { CodeBlockHookProps, CodeBlockOwnProps } from './code-block.js';

const LINE_HEIGHT_PX = 18;
// The top margin is larger because we don't need to make room for the horizontal scrollbar
// but we want the top and bottom margins to be the same when using autoHeight.
const MARGIN_TOP = 20;
const MARGIN_BOTTOM = 4;
const MARGIN = MARGIN_TOP + MARGIN_BOTTOM;

export const useCodeBlock = (props: CodeBlockOwnProps): CodeBlockHookProps => {
  const { code, height = '200px', autoHeight } = props;

  const computedHeight = useMemo(() => {
    if (autoHeight) {
      // Extra 1 line is for horizontal scroll bar which can cause vertical scroll if present
      const lineCount = code.split('\n').length + 1;
      return `${lineCount * LINE_HEIGHT_PX + MARGIN}px`;
    }

    return height;
  }, [autoHeight, code, height]);

  return { computedHeight };
};
